import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  customer_start?: string;
  customer_end?: string;
  sc_start?: string;
  sc_end?: string;
}

export interface ReportItem {
  // From FC110
  fc110_01: string;   // S/C No
  fc110_11: string;   // S/C date
  fc110_12: string;   // Customer code
  fc110_14: string;   // Customer order no
  fc110_22: string;   // Payment term code
  fc110_221: string;  // Payment term description
  fc110_58: number;   // Order category

  // From FC111
  fc111_02: number;   // Item seq
  fc111_11: string;   // Product name (code1+code2)
  fc111_12: string;   // Delivery date
  fc111_13: number;   // Sales qty
  fc111_14: string;   // Unit
  fc111_17: number;   // Payable comm rate
  fc111_19: number;   // Comm adjustment
  fc111_21: string;   // Product spec
  fc111_29: string;   // Remark code
  fc111_291: string;  // Remark description
  fc111_55: string;   // Customer product code
  fc111_151: number;  // Main set qty
  fc111_152: number;  // Sub set qty

  // From FC115
  fc115_03: number;   // Color seq
  fc115_11: string;   // Color code
  fc115_12: string;   // Color name 1
  fc115_13: string;   // Color name 2
  fc115_14: number;   // Color qty
  fc115_16: string;   // Color remark
  fc115_19: string;   // Color customer code
}

export interface ReportData {
  items: ReportItem[];
  total_count: number;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const c322Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    // Remove empty string params to keep URL clean
    const params: Record<string, string> = {};
    for (const [k, v] of Object.entries(filter)) {
      if (v && v.trim() !== '') {
        params[k] = v.trim();
      }
    }
    const res = await apiClient.get('/api/c322/report', { params });
    return res.data;
  },
};
